const COMMUNITY_ENDPOINTS = {
  POSTS: '/api/community/posts',
  COMMENTS: '/api/community/comments',
  REPORTS: '/api/community/comment-reports',
  CATEGORIES: '/api/community/categories',
  TAGS: '/api/community/tags',
  CHALLENGES: '/api/community/challenges',
  LEARNING_PATHS: '/api/community/learning-paths',
  USERS: '/api/community/users',
  PROGRESS: '/api/community/progress',
  LEGAL: '/api/community/legal',
  CERTIFICATES: '/api/community/certificate',
  IMAGE_UPLOAD: '/api/community/upload-image/',
  NOTIFICATIONS: '/api/community/notifications',
  ADMIN: {
    USERS: '/api/community/admin/users'
  },
  AUTH: {
    REGISTER: '/api/auth/community/register/',
    LOGIN: '/api/auth/community/login/',
    LOGOUT: '/api/auth/community/logout/',
    SESSION: '/api/auth/community/session/',
    REFRESH: '/api/auth/community/refresh/',
    VERIFY_OTP: '/api/auth/community/verify-otp/',
    RESEND_OTP: '/api/auth/community/resend-otp/',
    FORGOT_PASSWORD: '/api/community/forgot-password/',
    RESET_PASSWORD: '/api/community/reset-password/',
    GOOGLE_LOGIN: '/api/community/auth/google/'
  }
};

export default COMMUNITY_ENDPOINTS;
